
export function setSession (key, value) {
  if (value instanceof Object) {
    value = JSON.stringify(value)
  }
  localStorage.setItem(key, value)
}

export function getSession (key) {
  let obj = localStorage.getItem(key)
  if (typeof obj === 'string') {
    obj = JSON.parse(obj)
  }
  return obj
}

export function removeSession(key) {
  localStorage.removeItem(key)
}
export const tabStatus = 'mdd_tabStatus'

export const userInfo = 'mdd_userInfo'

export const ticketInfo = 'mdd_ticketInfo'

export const distributorTicketInfo = 'mdd_distributorTicketInfo' // 经销商的票的信息

export function getQueryString(name) { 
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); 
  var r = window.location.search.substr(1).match(reg); 
  if (r != null) return unescape(r[2]); 
  return null; 
} 

export function isPoneAvailable(str) {
  var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
  if (!myreg.test(str)) {
      return false;
  } else {
      return true;
  }
}

export const prefixPath = '/webchat'

export function isCardNo(card) { 
  // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X 
  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/; 
  if(reg.test(card) === false){ 
    return false; 
  } else {
    return true
  }
}

export const mailReg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;

export const wxName = '四川瑞通智晟科技有限公司';
export const userAccount = 'mdd_userAccount';


// WEBPACK FOOTER //
// ./src/utils/config.js